import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cls } from '@/lib/utils';

function ProjectsSectionItemSkeleton() {
  return (
    <div className={cls`flex flex-col gap-2`}>
      <Skeleton className={cls`w-full aspect-4/3 rounded-lg`} />
      <div className="flex justify-center">
        <Skeleton className={cls`w-1/3 h-5`} />
      </div>
    </div>
  );
}

export default ProjectsSectionItemSkeleton;
